export default __webpack_public_path__ + "static/roadmap-desktop_en_v2-6b5f5e002b5ce8696e7392dc8e5acb55.png";